// custom add wishlist
// document.dispatchEvent(new 
// CustomEvent("swym:collections-loaded"));


/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}
pagination_click_fun();
function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace product grid HTML
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination HTML
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); // added curent pagination link
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
        pagination_click_fun(); // reinit click event
      }
       // theme.reinitProductGridItem(); //this is theme defualt function
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }
  });
}


const main_gift_selector = document.querySelector('[gifit_data_product]') || null;
if(main_gift_selector){
main_gift_selector.addEventListener('change', function(event) {
        if (main_gift_selector.checked) {
            main_gift_selector.closest('product-single').querySelector('#gift-time').removeAttribute('disabled');
            main_gift_selector.closest('product-single').querySelector('#gift-product-data').removeAttribute('disabled');
            document.querySelector('#gift-time_gift-set-id').value = event.currentTarget.getAttribute('data-pro-id');
        } else {
             main_gift_selector.closest('product-single').querySelector('#gift-time').setAttribute('disabled','');
             main_gift_selector.closest('product-single').querySelector('#gift-product-data').setAttribute('disabled','');
            document.querySelector('#gift-time_gift-set-id').value = '';
        }
    });
}

$('.image_with_text_slider_wrapper').slick({
  dots: true,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 1,
  appendDots: $('.image_with_text_slider_dots')
});

$(document).on('click', '.custom-div_sort .cstm_sort_label', function (e) {
  $('.custom-div_sort ul.cstm-sorting_wrp').toggle();
  $(this).toggleClass('active');
});

$(document).on('click', function (e) {
  if ($(e.target).closest('.custom-div_sort').length === 0) {
    $('.custom-div_sort .cstm_sort_label').removeClass('active');
     $('.cstm-sorting_wrp').slideUp();
  }
});

$(document).on('click', '.custom_faq_details', function (e) {
  var data_title = $(this).attr('data_cate');
  $('.custom_faq_item').removeClass('active');
  $(this).parents('li').addClass('active');
  $('.custom_faq_data[data_cate]').attr('hidden','hidden');
  $('.custom_faq_data[data_cate="'+ data_title +'"]').removeAttr("hidden");

  $('.custom_faq_artical[data_cate]').attr('hidden','hidden');
  $('.custom_faq_artical[data_cate="'+ data_title +'"]').removeAttr("hidden");
});

$('[data-slider_custom]').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow:
      `<button type="button" class="navigation__button custom_btn_div_prev navigation__button--prev" data-navigation-prev>
        <svg xmlns="http://www.w3.org/2000/svg" width="34.785" height="25.288" viewBox="0 0 34.785 25.288">
          <g id="Icon_feather-arrow-up-right" data-name="Icon feather-arrow-up-right" transform="translate(32.902 14.512) rotate(135)">
            <g id="Group_69592" data-name="Group 69592" transform="translate(7.9 46.895) rotate(-135)">
              <path id="Path_111414" data-name="Path 111414" d="M22.077,36.669c-1.6,1.888-4.283-.284-5.728-1.25L8.156,29.938a3.121,3.121,0,0,1-1.1-1.03c-.7-1.314.656-2.74,1.818-3.671a41.939,41.939,0,0,0,6.783-6.849,14.657,14.657,0,0,1,3.65-3.8c1.223-.734,3.769-.963,3.125,1.264-.221.762-2.414,3.168-2.933,3.737-2.38,2.61-3.156,3.39-5.537,6L36.171,25a5.1,5.1,0,0,1,2.313.3,1.745,1.745,0,0,1,1.07,1.884c-.277,1.04-1.622,1.28-2.7,1.317-7.549.262-15.777.4-23.328.586,1.841,1.191,5.741,3.491,7.6,4.691.92.6,1.787,1.915.954,2.9Z" transform="translate(0 0)" fill="#1e1e1c" stroke="#fff" stroke-width="2"/>
            </g>
          </g>
        </svg>
      </button>`,
    nextArrow:
      `<button type="button" class="navigation__button custom_btn_div_next navigation__button--next" data-navigation-next>
        <svg xmlns="http://www.w3.org/2000/svg" width="34.786" height="25.288" viewBox="0 0 34.786 25.288">
          <g id="Group_69593" data-name="Group 69593" transform="translate(1.034 1.013)">
            <path id="Path_111414" data-name="Path 111414" d="M24.382,36.669c1.6,1.888,4.283-.284,5.728-1.25L38.3,29.938a3.121,3.121,0,0,0,1.1-1.03c.7-1.314-.656-2.74-1.818-3.671A41.939,41.939,0,0,1,30.8,18.388a14.657,14.657,0,0,0-3.65-3.8c-1.223-.734-3.769-.963-3.125,1.264.221.762,2.414,3.168,2.933,3.737,2.38,2.61,3.156,3.39,5.537,6L10.288,25a5.1,5.1,0,0,0-2.313.3,1.745,1.745,0,0,0-1.07,1.884c.277,1.04,1.622,1.28,2.7,1.317,7.549.262,15.777.4,23.328.586-1.841,1.191-5.741,3.491-7.6,4.691-.92.6-1.787,1.915-.954,2.9Z" transform="translate(-6.863 -14.075)" fill="#1e1e1c" stroke="#fff" stroke-width="2"/>
          </g>
        </svg>
        </button>`
      ,
    responsive: [
      {
        breakpoint: '768',
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: '1025',
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

if($(window).innerWidth() <= 767) {
  $('.custom_slider_hide').remove();
  $('[Custom-collection-slider]').slick({
       responsive: [
          {
             breakpoint: 767,
             settings:{
               slidesToShow: 1,
               slidesToScroll: 1,
               dots: true,
               arrows: false,
               autoplay: false,
               autoplaySpeed: 2000,
             }           
          }
       ]
    });

  $('[data-slider_custom_v2]').removeClass('grid-layout grid-layout--4 grid-layout6--2@mob');
    $('[data-slider_custom_v2]').slick({
       responsive: [
          {
             breakpoint: 767,
             settings:{
               slidesToShow: 2,
               slidesToScroll: 2,
               dots: true,
               arrows: false,
               autoplay: false,
               autoplaySpeed: 2000,
             }           
          }
       ]
    });
}



class CartProductGift extends HTMLElement {
  constructor() {
    super();
    const checkBox = this.querySelector('[data-select-input]');
    checkBox.addEventListener('change', this.addremovegift.bind(this));
  }

  async addremovegift(event) {
    if(event.currentTarget.checked){
      var gift_check = document.querySelector('[data-product-gift-cart]') || null;
      const now_time= Date.now();
      if(!gift_check) return;
      var form_cart_cust = gift_check.querySelector('form') || null;      
      console.log(form_cart_cust);
      if(!form_cart_cust) return;
      form_cart_cust.querySelector('#gift-time_gift-set-id').value = now_time;
      const data_custom = new FormData(form_cart_cust);
      console.log("data_custom",data_custom);
      const item_cust_cart = Object.fromEntries(data_custom.entries());
      console.log("data_custom_cart",item_cust_cart);
      const main_wapper = event.currentTarget.closest('cart-item') || null;
      const key = main_wapper.getAttribute('key');
      const qty = main_wapper.querySelector('quantity-input input').value;
         if(key){
        const body = JSON.stringify({
                  'id':key,
                  'quantity': qty,
                 'properties': {'_gift_time': now_time,'_gift card':item_cust_cart.id}
                });
        await window.theme.cart.store.getState().changeCustom(key,qty,body);
      }
      
      await window.theme.cart.store.getState().add(item_cust_cart);
      await window.theme.cart.store.getState().resetVariantsBeingAdded();
             await window.theme.cart.store
        .getState()
        .resetVariantsBeingAdded(item_cust_cart.id);
    }else{
      document.querySelector('#gift-time_gift-set-id').value = '';
      const main_wapper = event.currentTarget.closest('cart-item') || null;
      if(!main_wapper) return;
      console.log(main_wapper);
      const key = main_wapper.getAttribute('key');
      const qty = main_wapper.querySelector('quantity-input input').value;
      const giftprokey = document.querySelector("[product-line-id='"+event.currentTarget.getAttribute('data-gift-time')+"']") || null;
       if(giftprokey){
         console.log(giftprokey);
         const giftprokey_id = giftprokey.getAttribute('key');
         await window.theme.cart.store.getState().change(giftprokey_id,0);
       }
      // if(key){
      //   const body = JSON.stringify({
      //             'id':key,
      //             'quantity': qty,
      //            'properties': {'_Gift_remove': true}
      //           });
      //   await window.theme.cart.store.getState().changeCustom(key,qty,body);
      // }
    }
  }
}
customElements.define('card-gift-data', CartProductGift);



document.querySelectorAll('.card_pdp_image_sw').forEach(function(item) {
    item.addEventListener('mouseover', function() {
        var hover_img = item.querySelector('img').getAttribute('hover_img');
        var item_f = item.closest('.product-card-top');
        var image_src =item_f.querySelector('.product-card__img');
        image_src.removeAttribute('srcset');
        image_src.src = hover_img;
    });

     item.addEventListener('mouseleave', function() {
       var item_f = item.closest('.product-card-top');
       var image_src = item_f.querySelector('.product-card__img');
       image_src.src = image_src.getAttribute('main_src');
     });
});

